import { useMemo } from "react";
import { DISCOVER_GAMES_PRIORITY_FILTER_OPTIONS } from "../../../../datagrid-configs/discoverGames";
import client from "libs/client";
import { _ } from "i18n";
import type { ProgramGameSelectOption } from "./types";

export function useProgramGameSelectOptions(isOpen: boolean) {
	const fixturesQuery = client.getDiscoverGamesProgramGameFixtures.useQuery({
		enabled: isOpen,
		staleTime: 60_000,
	});

	const typeOptions = useMemo<ProgramGameSelectOption[]>(() => {
		const raw = fixturesQuery.data?.data?.gameTypes;
		if (!raw || !Array.isArray(raw)) {
			return [];
		}
		return raw.map((item) => ({
			value: item.value,
			label: item.label,
		}));
	}, [fixturesQuery.data]);

	const nationalOptions = useMemo<ProgramGameSelectOption[]>(
		() => [
			{ value: "true", label: _("discover.gamesTable.programGame.boolean.true") },
			{ value: "false", label: _("discover.gamesTable.programGame.boolean.false") },
		],
		[],
	);

	const priorityOptions = useMemo<ProgramGameSelectOption[]>(
		() =>
			DISCOVER_GAMES_PRIORITY_FILTER_OPTIONS.map((item) => ({
				value: String(item.value),
				label: item.label,
			})),
		[],
	);

	const typesLoading = fixturesQuery.isLoading || fixturesQuery.isFetching;

	return { typeOptions, nationalOptions, priorityOptions, typesLoading };
}
